import { render, staticRenderFns } from "./company-files-widget.vue?vue&type=template&id=77106e1c&scoped=true&"
import script from "./company-files-widget.vue?vue&type=script&lang=js&"
export * from "./company-files-widget.vue?vue&type=script&lang=js&"
import style0 from "./company-files-widget.vue?vue&type=style&index=0&id=77106e1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77106e1c",
  null
  
)

export default component.exports